import React, { Component } from 'react';
import { verifierCodeMFA } from '../../../App_Code/API';
import { EnvoyerCodeMFA } from '../../../App_Code/API';
import * as HttpStatus from '../../../App_Data/HttpStatus';

const MESSAGE_CODE_EXPIRE = "Code expiré.";
const MESSAGE_COMPTE_BLOQUE = "Compte bloqué pendant 15 minutes";

class PageSaisieMFA extends Component {
    constructor(props) {
        super(props);
        const { location } = props;
        const kelId =
            location && location.state && location.state.kelId
                ? location.state.kelId
                : new URLSearchParams(location.search).get('kelId');

        this.state = {
            kelId,
            email: sessionStorage.getItem('email') || '',
            codeMFA: '',
            erreur: '',
            message: '',
            envoiEnCours: false,
            btnContinuer: true,
            btnRenvoyer: true,
            cacheFormulaire: false,
        };
    }
    
    handleChange = event => {
        this.setState({
            codeMFA: event.target.value,
            erreur: '',
            btnContinuer: true,
        });
    };

    handleSubmit = event => {
        event.preventDefault();
        const { email, codeMFA } = this.state;
        const code = codeMFA.trim();

        if (!/^\d{6}$/.test(code)) {
            this.setState({
                erreur: 'Veuillez saisir un code à 6 chiffres.',
                message: '',
            });
            return;
        }

        this.setState({ envoiEnCours: true, erreur: '', message: '', btnContinuer: true });
        console.log('Vérification du code MFA :',  'email:', email, 'code:', code);

        verifierCodeMFA(email, code).then((response => {
                if (response.status === HttpStatus.OK) {
                    this.props.history.push('/Chargement');
                    return;
                }else{
                    const erreur = response.data.Message || 'Code incorrect. Veuillez réessayer.'
                    this.setState({
                        erreur,
                        envoiEnCours: false,
                        btnContinuer: erreur !== MESSAGE_CODE_EXPIRE && erreur !== MESSAGE_COMPTE_BLOQUE,
                        btnRenvoyer: erreur !== MESSAGE_COMPTE_BLOQUE,
                        cacheFormulaire: erreur === MESSAGE_COMPTE_BLOQUE || erreur === MESSAGE_CODE_EXPIRE,
                    });
                    
                }
            }))
                
            .catch(() => {
                this.setState({
                    erreur: 'Une erreur est survenue lors de la vérification du code.',
                    btnContinuer: true,
                    envoiEnCours: false,
                });
            });
    };
    
    handleRenvoyerCode = event => {
        const { email } = this.state;
  
        EnvoyerCodeMFA(email).then((response => {
            if (response.status === HttpStatus.OK) {
                    this.setState({
                        message: 'Un nouveau code a été envoyé à votre adresse e-mail.',
                        erreur: '',
                        btnContinuer: true,
                        btnRenvoyer: true,
                        codeMFA: '',
                        cacheFormulaire: false,
                    });
            } else {
                this.setState({
                    erreur: response.data.Message || 'Impossible d’envoyer le code.',
                    envoiEnCours: false,
                    btnRenvoyer: true,
                });
            }
        }))
        .catch(() => {
            this.setState({
                erreur: 'Une erreur est survenue lors de l’envoi du code.',
                envoiEnCours: false,
            });
        });
    };

    render() {
        const { codeMFA, erreur, message, envoiEnCours, btnContinuer, btnRenvoyer, cacheFormulaire } = this.state;
        const { email } = this.state;
        return (
            <div className="text-center p-4">
                <h2>Authentification</h2>

                
                {!cacheFormulaire && (
                <form onSubmit={this.handleSubmit}>
                    <p>Vous avez reçu un code à 6 chiffres à l'adresse {email} <b>valable 10 minutes</b>.</p>
                    <p>Veuillez saisir ce code ci-dessous pour continuer.</p>
                    <div className="form-group">
                        <input
                            id="codeMFA"
                            type="text"
                            inputMode="numeric"
                            pattern="[0-9]{6}"
                            className="form-control"
                            value={codeMFA}
                            onChange={this.handleChange}
                            maxLength="6"
                            autoComplete="one-time-code"
                        />
                       
                    </div>

                    {btnContinuer && (
                    <button
                        type="submit"
                        className="btn btn-success btn-block"
                        disabled={envoiEnCours}
                    >
                        Continuer
                    </button>
                     )}
                </form>
                )}
                {erreur && <div className="text-danger mb-3">{erreur}</div>}
                {message && <div className="text-success mb-3">{message}</div>}
                
                {btnRenvoyer && (
                <button
                    type="button"
                    className="btn btn-link mt-3"
                    onClick={this.handleRenvoyerCode}
                    disabled={envoiEnCours}
                >
                    Renvoyer un nouveau code
                </button>
                )}
                
            </div>
        );
    }
}

export default PageSaisieMFA;


// WEBPACK FOOTER //
// ./src/components/Adherent/MFA/index.js